/* eslint-disable react/jsx-no-target-blank */
import {useEffect} from 'react';
import {useIntl} from 'react-intl';
//import {KTSVG} from '../../../helpers';
import {AsideMenuItemWithSub} from './AsideMenuItemWithSub';
import {AsideMenuItem} from './AsideMenuItem';
import {useAuth} from 'src/app/modules/auth';
//import {requestPOST, requestDELETE} from 'src/utils/baseAPI';
//import {useEffect, useState} from 'react';
import _ from 'lodash';
//import {getUserByToken, getBranchByToken} from 'src/app/modules/auth/core/_requests';
import * as authHelper from 'src/app/modules/auth/core/AuthHelpers';
//import {BranchModel} from '../../../../app/modules/auth/core/_models';
import {useDispatch, useSelector} from 'react-redux';
import * as actionsGlobal from 'src/setup/redux/global/Actions';
import * as modal from 'src/setup/redux/modal/Actions';
import {requestGET} from 'src/utils/baseAPI';

export function AsideMenuMain() {
  const dispatch = useDispatch();
  const intl = useIntl();

  const {currentUser} = useAuth();
  const {token} = authHelper.getAuth();
  const decodedToken = atob(token.split('.')[1]);
  const tokenObject = JSON.parse(decodedToken);

  const REACT_APP_REGISTRATION = process.env.REACT_APP_REGISTRATION;
  console.log(currentUser);
  const CheckRole = (role) => {
    if (!currentUser?.permissons) {
      return false;
    }

    return currentUser?.permissons?.some((v) => role.includes(v));
  };
  const CheckRoleRoot = (role) => {
    if (!tokenObject?.permission) {
      return false;
    }
    return tokenObject?.permission?.includes(role);
  };
  // useEffect(() => {
  //   if (token) {
  //     dispatch(actionsGlobal.listenNotifications(token));
  //   } else {
  //     if (connection) {
  //       connection.stop().then((e) => {
  //         console.log('stop tai day!');
  //       });
  //     }
  //   }
  //   return () => {};
  // }, [token]);

  useEffect(() => {
    const fetchData = async () => {
      const res = await requestGET(`api/v1/settingconfigs/${currentUser.id}`);

      if (res && res.data) {
        const shareData = res.data.shareData ?? false;
        if (shareData) {
          dispatch(actionsGlobal.setCurrentBranch(null));
        }
      }
    };
    fetchData();

    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {(CheckRole('Dashboard.View') || CheckRoleRoot('Dashboard.View')) && (
        <AsideMenuItem
          to='/systems/dashboard'
          title='Dashboard'
          hasBullet={true}
          fontIcon='abstract-26'
        />
      )}


      <AsideMenuItemWithSub
        to='/systems/catalogues'
        title={intl.formatMessage({id: 'MENU.GENERAL'})}
        icon='/media/icons/duotune/layouts/lay002.svg'
        fontIcon='bi-person'
      >
        {/* <AsideMenuItem
          to='/systems/catalogues/parkingzones'
          title='Khu vực bãi đỗ xe'
          hasBullet={true}
          
        /> */}
        {(CheckRole('VehicleClasses.WebManage') || CheckRoleRoot('VehicleClasses.WebManage')) && (
          <AsideMenuItem
            to='/systems/catalogues/vehicletypes'
            title={intl.formatMessage({id: 'MENU.VEHICLETYPE'})}
            hasBullet={true}
          />
        )}

        {(CheckRole('Customers.WebManage') || CheckRoleRoot('Customers.WebManage')) && (
          <AsideMenuItem
            to='/systems/catalogues/customergroups'
            title={intl.formatMessage({id: 'MENU.CUSTOMERGROUP'})}
            hasBullet={true}
          />
        )}
        <AsideMenuItem
          to='/systems/catalogues/branchs'
          title={intl.formatMessage({id: 'MENU.BRANCH'})}
          hasBullet={true}
        />

        {/* <AsideMenuItem
          to='/systems/catalogues/registerapp'
          title='Thuê bao sử dụng phần mềm (Admin)'
          hasBullet={true}
        />    */}
        {/* <AsideMenuItem
          to='/systems/catalogues/registerextendapp'
          title='Thuê bao hết hạn phần mềm (Admin)'
          hasBullet={true}
        /> */}
      </AsideMenuItemWithSub>
      <AsideMenuItemWithSub
        to='/systems/parking'
        title={intl.formatMessage({id: 'MENU.PARKING'})}
        icon='/media/icons/duotune/ecommerce/ecm006.svg'
        fontIcon='bi-person'
      >
        {(CheckRole('Tickets.WebManage') || CheckRoleRoot('Tickets.WebManage')) && (
          <AsideMenuItem
            to='/systems/parking/tickets'
            title={intl.formatMessage({id: 'MENU.TICKET'})}
            hasBullet={true}
          />
        )}
        {/* <AsideMenuItem
          to='/systems/parking/vehicles'
          title='Danh sách phương tiện'
          hasBullet={true}
        /> */}
       
        {/* {(CheckRole('SubScriptions.WebManage') || CheckRoleRoot('SubScriptions.WebManage')) && (
          <AsideMenuItem
            to='/systems/parking/registermonthlytickets'
            title={intl.formatMessage({id: 'MENU.SUBSCRIBER'})}
            hasBullet={true}
          />
        )}  */}

      {(CheckRole('SubScriptions.WebManage') || CheckRoleRoot('SubScriptions.WebManage')) && (
          <AsideMenuItem
            to='/systems/parking/subscriptions'
            title="Danh sách thuê bao"
            hasBullet={true}
          />
        )} 
        {(CheckRole('Tickets.WebManage') || CheckRoleRoot('Tickets.WebManage')) && (
          <AsideMenuItem
            to='/systems/parking/subscriptiontiers'
            title="Gói đăng ký"
            hasBullet={true}

          />
        )}
        {(CheckRole('BlacklistItems.WebManage') || CheckRoleRoot('BlacklistItems.WebManage')) && (
          <AsideMenuItem
            to='/systems/parking/vehicleblacklists'
            title={intl.formatMessage({id: 'MENU.BLACKLIST'})}
            hasBullet={true}
          />
        )}

        {(CheckRole('Coupons.WebManage') || CheckRoleRoot('Coupons.WebManage')) && (
          <AsideMenuItem
            to='/systems/parking/coupons'
            title="Thẻ giảm giá"
            hasBullet={true}
          />
        )}

      
        {/* <AsideMenuItem
          to='/systems/parking/historyextends'
          title={intl.formatMessage({id: 'MENU.EXTENDSUBSCRIBERHISTORY'})}
          hasBullet={true}
        />
        <AsideMenuItem
          to='/systems/parking/historyrenews'
          title={intl.formatMessage({id: 'MENU.RENEWSUBSCRIBERHISTORY'})}
          hasBullet={true}
        /> */}

      </AsideMenuItemWithSub>
      <AsideMenuItemWithSub
        to='/systems/manages'
        title={intl.formatMessage({id: 'MENU.MANAGE'})}
        icon='/media/icons/duotune/general/gen008.svg'
        fontIcon='bi-person'
      >
        {/* {(CheckRole('Customers.WebManage') || CheckRoleRoot('Customers.WebManage')) && (
          <AsideMenuItem
            to='/systems/manages/customers'
            title={intl.formatMessage({id: 'MENU.CUSTOMER'})}
            hasBullet={true}
          />
        )} */}
        {(CheckRole('Users.WebManage') || CheckRoleRoot('Users.WebManage')) && (
          <AsideMenuItem
            to='/systems/manages/users'
            title={intl.formatMessage({id: 'MENU.USER'})}
            hasBullet={true}
          />
        )}
        <AsideMenuItem to='/systems/manages/roles' title='Danh sách quyền' hasBullet={true} />

        {/* <AsideMenuItem to='/systems/manages/clientsyncs' title='Client kết nối' hasBullet={true} /> */}
      </AsideMenuItemWithSub>
      <AsideMenuItemWithSub
        to='/systems/statistics'
        title={intl.formatMessage({id: 'MENU.STATISTICS'})}
        icon='/media/icons/duotune/general/gen032.svg'
        fontIcon='bi-person'
      >
        {REACT_APP_REGISTRATION == 'ESCHOOL' && (
          <AsideMenuItem
            to='/systems/statistics/eventvehicleparent'
            title='Danh sách xe phụ huynh đang chờ'
            hasBullet={true}
          />
        )}
        {(CheckRole('InOuts.WebManage') ||
          CheckRoleRoot('InOuts.WebManage') ||
          CheckRole('InOuts.WebView') ||
          CheckRoleRoot('InOuts.WebView')) && (
          <>
            <AsideMenuItem
              to='/systems/statistics/eventvehicleinouts'
              title={intl.formatMessage({id: 'MENU.INOUTSHISTORY'})}
              hasBullet={true}
            />
            <AsideMenuItem
              to='/systems/statistics/entryexitevent'
              title={intl.formatMessage({id: 'MENU.ENTRYEXITEVENTS'})}
              hasBullet={true}
            />

            <AsideMenuItem
              to='/systems/statistics/eventvehicleparking'
              title={intl.formatMessage({id: 'MENU.VEHICLEINPARKING'})}
              hasBullet={true}
            />
            <AsideMenuItem
              to='/systems/statistics/eventvehiclegeneral'
              title={intl.formatMessage({id: 'MENU.GENERALREPORTVEHICLEINOUTS'})}
              hasBullet={true}
            />
          </>
        )}
        {(CheckRole('Revenues.WebManage') || CheckRoleRoot('Revenues.WebManage')) && (
          <>
            <AsideMenuItem
              to='/systems/statistics/revenues'
              title={intl.formatMessage({id: 'MENU.REVENUEREPORT'})}
              hasBullet={true}
            />
            <AsideMenuItem
              to='/systems/statistics/revenuedays'
              title={intl.formatMessage({id: 'MENU.DAILYREVENUEREPORTDETAIL'})}
              hasBullet={true}
            />
            <AsideMenuItem
              to='/systems/statistics/vehiclemonthlyinvoices'
              title={intl.formatMessage({id: 'MENU.SUBSCRIBERREVENUEREPORT'})}
              hasBullet={true}
            />
          </>
        )}
        {/* <AsideMenuItem
          to='/systems/statistics/ticketused'
          title='Báo cáo sử dụng vé tháng'
          hasBullet={true}
        />
        <AsideMenuItem
        to='/systems/statistics/roles'
        title='Biểu đồ thống kê số lượt xe vào ra'
        hasBullet={true}
        /> */}


        {(CheckRole('Revenues.WebManage') || CheckRoleRoot('Revenues.WebManage')) && (
          <>
            <AsideMenuItem
              to='/systems/statistics/revenuechart'
              title={intl.formatMessage({id: 'MENU.REVENUESTATISTICSCHART'})}
              hasBullet={true}
            />

            <AsideMenuItem
              to='/systems/statistics/vehiclechart'
              title={intl.formatMessage({id: 'MENU.VEHICLEINOUTSTATISTICSCHART'})}
              hasBullet={true}
            />
            <AsideMenuItem
              to='/systems/statistics/registermonthlychart'
              title={intl.formatMessage({id: 'MENU.NEWSUBSCRIBERREGISTRATIONSTATISTICSCHART'})}
              hasBullet={true}
            />
          <AsideMenuItem
            to='/systems/statistics/losttickets'
            title='Thống kê vé mất'
            hasBullet={true}
          />
          </>
        )}
        <AsideMenuItem
          to='/systems/statistics/actionlogitem'
          title={intl.formatMessage({id: 'ACTIONLOG.TITLE'})}
          hasBullet={true}
        />
      </AsideMenuItemWithSub>
    </>
  );
}
